import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import { makeRecursiveMapper, mergeCellProps, collectNodes, isLeafNode, isSelectColumn } from '../../utils';
import { FILL_COLUMN_CODE } from './autoFill';
import { getEventCoordinates, hasMovedEnough, addPointerEventListeners, removePointerEventListeners } from './utils/touchEventUtils';
var stateKey = 'columnDrag';
var SCROLL_SIZE = 30;
function disableSelect(event) {
  event.preventDefault();
}
function sortColumns(columns, sort) {
  var res = new Array(columns.length);
  var lastColumns = _toConsumableArray(columns);
  while (columns.length) {
    var cloumn = columns.pop();
    res[sort[cloumn.code]] = cloumn;
  }
  if (_filterInstanceProperty(res).call(res, Boolean).length !== lastColumns.length) {
    return lastColumns;
  }
  return res;
}
function stopClickPropagation(e) {
  e.stopPropagation();
}
function adjustTranslation(isRTL) {
  return function (value) {
    return isRTL ? -value : value;
  };
}
export function columnDrag() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (pipeline) {
    var direction = pipeline.ctx.direction;
    var _adjustTranslation = adjustTranslation(direction === 'rtl');
    var _pipeline$getStateAtK = pipeline.getStateAtKey(stateKey, {}),
      cloumnsTranslateData = _pipeline$getStateAtK.cloumnsTranslateData;
    var columns = pipeline.getColumns();
    var tableBody = pipeline.ref.current.domHelper && pipeline.ref.current.domHelper.tableBody;
    // if (cloumnsSortData) {
    //   columns = sortColumns(columns, cloumnsSortData)
    // }
    pipeline.columns(_filterInstanceProperty(columns).call(columns, function (column) {
      return column;
    }));
    return pipeline.mapColumns(makeRecursiveMapper(function (col, recursiveFlatMapInfo) {
      var path = recursiveFlatMapInfo.path,
        isLeaf = recursiveFlatMapInfo.isLeaf;
      var style = cloumnsTranslateData ? {
        transition: '.3s',
        transform: "translate3d(".concat(cloumnsTranslateData[col.code], "px, 0px, 0px)")
      } : {};
      var prevGetCellProps = col.getCellProps;
      // !col.code: 选择列 col.lock: 固定列 不允许拖拽
      if (col.lock || !col.code) return col;
      return _extends(_extends({}, col), {
        getCellProps: function getCellProps(value, record, rowIndex) {
          var prevCellProps = prevGetCellProps === null || prevGetCellProps === void 0 ? void 0 : prevGetCellProps(value, record, rowIndex);
          return mergeCellProps(prevCellProps, {
            style: style
          });
        },
        headerCellProps: mergeCellProps(col.headerCellProps, _extends(_extends({}, isLeaf && path.length === 1 ? {
          onMouseDown: function onMouseDown(e) {
            if (e.button !== 0 || !e.currentTarget.contains(e.target)) {
              return;
            }
            handlePointerDown(e.nativeEvent, false, e.currentTarget);
          },
          onTouchStart: function onTouchStart(e) {
            // 阻止触摸事件的默认行为
            if (e.cancelable) {
              e.preventDefault();
            }
            handlePointerDown(e.nativeEvent, true, e.currentTarget);
          }
        } : {}), {
          style: style
        }))
      });
      // 统一的拖拽处理函数
      function handlePointerDown(startEvent, isTouch, currentTarget) {
        var _a;
        window.addEventListener('selectstart', disableSelect);
        var columnMoved = false;
        var columns = pipeline.getColumns();
        var _pipeline$getStateAtK2 = pipeline.getStateAtKey(stateKey, {}),
          cloumnsTranslateData = _pipeline$getStateAtK2.cloumnsTranslateData;
        var cloumnsSortData = {};
        columns.forEach(function (item, index) {
          cloumnsSortData[item.code] = index;
        });
        var rect = (_a = currentTarget.parentElement) === null || _a === void 0 ? void 0 : _a.getClientRects()[0];
        if (!rect) return;
        var startX = direction === 'rtl' ? rect.right : rect.left;
        var startCoordinates = getEventCoordinates(startEvent);
        var mouseDownClientX = startCoordinates.clientX;
        var mouseDownClientY = startCoordinates.clientY;
        var moveData = [];
        var allColumns = collectNodes(columns);
        var tableBodyClientRect = tableBody.getBoundingClientRect();
        var startScrollLeft = pipeline.ref.current.domHelper.virtual.scrollLeft;
        var updateScrollPosition = function updateScrollPosition(client) {
          var clientX = client.clientX;
          var left = tableBodyClientRect.left,
            width = tableBodyClientRect.width;
          if (clientX + SCROLL_SIZE >= left + width) {
            pipeline.ref.current.domHelper.virtual.scrollLeft += SCROLL_SIZE;
          }
          if (clientX - SCROLL_SIZE <= left) {
            pipeline.ref.current.domHelper.virtual.scrollLeft -= SCROLL_SIZE;
          }
        };
        function handlePointerMove(e) {
          // 触摸事件需要阻止默认行为，防止页面滚动
          if (isTouch && e.cancelable) {
            e.preventDefault();
          }
          var coordinates = getEventCoordinates(e);
          var client = {
            clientX: coordinates.clientX,
            clientY: coordinates.clientY
          };
          var scrollDistance = pipeline.ref.current.domHelper.virtual.scrollLeft - startScrollLeft;
          var startPosition = startX - scrollDistance; // 表头最左边起点
          var offsetDistance = direction === 'rtl' ? startPosition - coordinates.clientX : coordinates.clientX - startPosition;
          updateScrollPosition(client);
          if (offsetDistance < 20) {
            return;
          } else {
            e.stopPropagation();
          }
          document.body.style.userSelect = 'none';
          currentTarget.style.cursor = 'move';
          // 重置位置信息
          cloumnsTranslateData = {};
          allColumns.forEach(function (item) {
            cloumnsTranslateData[item.code] = 0;
          });
          // 计算平移位置
          var replaceIndex = 0;
          var totalWitdth = getColumnWidth(columns[replaceIndex]);
          while (totalWitdth < offsetDistance && replaceIndex < columns.length - 1) {
            replaceIndex++;
            totalWitdth += getColumnWidth(columns[replaceIndex]);
          }
          // 需要取最新startIndex, 不能直接用makeRecursiveMapper提供的startIndex（因为map时还没添加选择列、充满列等后面use添加的列）
          var startIndex;
          columns.forEach(function (column, index) {
            if (column.code === col.code) {
              startIndex = index;
            }
          });
          var optionColumn = columns[startIndex];
          var index = replaceIndex;
          if (startIndex > replaceIndex) {
            // 左移
            while (index < startIndex) {
              var _columns$index = columns[index],
                code = _columns$index.code,
                lock = _columns$index.lock,
                width = _columns$index.width,
                children = _columns$index.children;
              if (enableMove({
                code: code,
                lock: lock
              })) {
                cloumnsTranslateData[code] += _adjustTranslation(optionColumn.width);
                if (isLeafNode(columns[index])) {
                  cloumnsTranslateData[optionColumn.code] -= _adjustTranslation(width);
                } else {
                  cloumnsTranslateData[optionColumn.code] -= _adjustTranslation(getColumnWidth(columns[index]));
                  moveAllChildren(children, cloumnsTranslateData, _adjustTranslation(optionColumn.width));
                }
                columnMoved = true;
              }
              index++;
            }
          } else if (startIndex < replaceIndex) {
            // 右移
            while (startIndex < index) {
              var _columns$index2 = columns[index],
                _code = _columns$index2.code,
                _lock = _columns$index2.lock,
                _width = _columns$index2.width,
                _children = _columns$index2.children;
              if (enableMove({
                code: _code,
                lock: _lock
              })) {
                cloumnsTranslateData[_code] -= _adjustTranslation(optionColumn.width);
                if (isLeafNode(columns[index])) {
                  cloumnsTranslateData[optionColumn.code] += _adjustTranslation(_width);
                } else {
                  cloumnsTranslateData[optionColumn.code] += _adjustTranslation(getColumnWidth(columns[index]));
                  moveAllChildren(_children, cloumnsTranslateData, _adjustTranslation(optionColumn.width), true);
                }
                columnMoved = true;
              }
              index--;
            }
          }
          window.requestAnimationFrame(function () {
            pipeline.setStateAtKey(stateKey, {
              cloumnsTranslateData: cloumnsTranslateData
            });
            moveData = [startIndex, replaceIndex];
          });
        }
        function handlePointerUp(e) {
          removePointerEventListeners(document.body, {
            onPointerMove: handlePointerMove,
            onPointerUp: handlePointerUp
          }, isTouch);
          window.removeEventListener('selectstart', disableSelect);
          var endCoordinates = getEventCoordinates(e);
          if (hasMovedEnough(mouseDownClientX, mouseDownClientY, endCoordinates.clientX, endCoordinates.clientY)) {
            e.stopPropagation(); // 存在移动就阻止冒泡
            currentTarget.addEventListener('click', stopClickPropagation); // 阻止列头点击事件，防止拖动后触发列头过滤事件
          }

          window.requestAnimationFrame(function () {
            // 取消阻止列头点击事件
            currentTarget.removeEventListener('click', stopClickPropagation);
            currentTarget = null;
            var _moveData = moveData,
              _moveData2 = _slicedToArray(_moveData, 2),
              startIndex = _moveData2[0],
              replaceIndex = _moveData2[1];
            var optionColumn = columns[startIndex];
            var index = replaceIndex;
            if (startIndex > replaceIndex) {
              // 左移
              while (index < startIndex) {
                var _columns$index3 = columns[index],
                  code = _columns$index3.code,
                  lock = _columns$index3.lock;
                if (enableMove({
                  code: code,
                  lock: lock
                })) {
                  cloumnsSortData[code] += 1;
                  cloumnsSortData[optionColumn.code] -= 1;
                  columnMoved = true;
                }
                index++;
              }
            } else if (startIndex < replaceIndex) {
              // 右移
              while (index > startIndex) {
                var _columns$index4 = columns[index],
                  _code2 = _columns$index4.code,
                  _lock2 = _columns$index4.lock;
                if (enableMove({
                  code: _code2,
                  lock: _lock2
                })) {
                  cloumnsSortData[_code2] -= 1;
                  cloumnsSortData[optionColumn.code] += 1;
                  columnMoved = true;
                }
                index--;
              }
            }
            var onColumnDragStopped = opts.onColumnDragStopped;
            // 拖拽结束返回列顺序
            if (onColumnDragStopped) {
              var _context;
              var isRowDragColumn = function isRowDragColumn(code) {
                var rowDragColumnKey = pipeline.getFeatureOptions('rowDragColumnKey');
                return code === rowDragColumnKey;
              };
              var newColumns = _filterInstanceProperty(_context = sortColumns(columns, cloumnsSortData)).call(_context, function (column) {
                return column.code !== FILL_COLUMN_CODE && !isRowDragColumn(column.code) && !isSelectColumn(column);
              });
              // TODO drag需要在resize之后use,否则这里返回的列对应的宽度不是拖拽后的
              onColumnDragStopped(columnMoved, newColumns);
            }
            pipeline.setStateAtKey(stateKey, {
              cloumnsTranslateData: null
            });
          });
          document.body.style.userSelect = '';
          currentTarget.style.opacity = '';
          currentTarget.style.cursor = '';
        }
        var onColumnDragStart = opts.onColumnDragStart;
        onColumnDragStart && onColumnDragStart(col);
        addPointerEventListeners(document.body, {
          onPointerMove: handlePointerMove,
          onPointerUp: handlePointerUp
        }, isTouch);
      }
    }));
  };
}
function enableMove(_ref) {
  var lock = _ref.lock,
    code = _ref.code;
  return code && code !== FILL_COLUMN_CODE && !lock;
}
function getColumnWidth(col) {
  if (col.children) {
    return col.children.reduce(function (acc, col) {
      return acc + getColumnWidth(col);
    }, 0);
  }
  return col.width;
}
function moveAllChildren(cols, cloumnsTranslateData, width, isMinus) {
  cols.forEach(function (col) {
    var _a;
    var code = col.code,
      children = col.children;
    var movedWidth = (_a = cloumnsTranslateData[code]) !== null && _a !== void 0 ? _a : 0;
    cloumnsTranslateData[code] = movedWidth + (isMinus ? -width : width);
    if (!isLeafNode(col)) {
      moveAllChildren(children, cloumnsTranslateData, width);
    }
  });
}